import type { BrandColor } from '../../../types/color'
import type { IconComponent } from '../types'

/**
 * $ icon in a circle
 */
export const Dollar: IconComponent<Props> = ({
    width,
    height,
    color = 'step-cold-steel',
    ...restOfProps
}) => (
    <svg
        width={width}
        height={height}
        viewBox='0 0 20 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...restOfProps}
    >
        <circle
            cx='10'
            cy='10'
            r='7'
            stroke={`var(--${color}`}
            strokeWidth='1.5'
        />
        <path
            d='M12.016 11.2c0 .42-.138.771-.414 1.053-.27.276-.63.45-1.08.522v1.098H9.46v-1.116a2.461 2.461 0 0 1-.936-.423 2.42 2.42 0 0 1-.657-.792l.819-.612c.348.546.8.819 1.359.819.234 0 .423-.045.567-.135a.438.438 0 0 0 .216-.396.403.403 0 0 0-.171-.342c-.108-.09-.282-.183-.522-.279l-.612-.225c-.42-.156-.75-.363-.99-.621a1.377 1.377 0 0 1-.351-.945c0-.366.117-.678.35-.936.235-.264.544-.441.928-.531v-1.08h1.062v1.062c.594.126 1.04.471 1.34 1.035l-.81.612a1.47 1.47 0 0 0-.467-.459 1.07 1.07 0 0 0-.567-.153.874.874 0 0 0-.468.117c-.12.072-.18.186-.18.342 0 .132.048.24.144.324.102.078.255.159.459.243l.675.234c.456.168.798.384 1.026.648.228.258.342.57.342.936Z'
            fill={`var(--${color}`}
        />
    </svg>
)

interface Props {
    /**
     * Color of the icon
     */
    color?: BrandColor
}
